// Whether an image file is animated: product images must be static. Reads the file's own header, as browsers show
// any frames there are whatever the type. PNG: an APNG has an acTL chunk before its first IDAT. WebP: the VP8X
// header's animation flag. Other types (JPEG) can't be animated; GIF is refused by its type.
export async function isAnimatedImage(file: Blob): Promise<boolean> {
    const bytes = new Uint8Array(await file.arrayBuffer());
    const ascii = (at: number, length: number) => String.fromCharCode(...bytes.subarray(at, at + length));
    if (bytes.length >= 8 && bytes[0] === 0x89 && ascii(1, 3) === 'PNG') {
        const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        // Each chunk: a 4-byte length, its 4-letter type, the data, a 4-byte CRC.
        for (let at = 8; at + 8 <= bytes.length; at += 12 + view.getUint32(at)) {
            const type = ascii(at + 4, 4);
            if (type === 'acTL') {
                return true;
            }
            if (type === 'IDAT' || type === 'IEND') {
                return false;
            }
        }
        return false;
    }
    if (bytes.length >= 21 && ascii(0, 4) === 'RIFF' && ascii(8, 4) === 'WEBP') {
        // The extended format's first chunk, VP8X, has the flags at byte 20; 0x02 is animation.
        return ascii(12, 4) === 'VP8X' && (bytes[20] & 0x02) !== 0;
    }
    return false;
}
